import React from 'react';
import {
  TrendingUp,
  ShieldCheck,
  Users,
  ClipboardCheck,
  Target,
  Calculator,
  HeartHandshake,
  Lightbulb,
  MessageCircle
} from 'lucide-react';
import { mypesPromoData, contactData } from '../../data/mock';
import '../../styles/landing.css';

const iconMap = {
  TrendingUp: TrendingUp,
  ShieldCheck: ShieldCheck,
  Users: Users,
  ClipboardCheck: ClipboardCheck,
  Target: Target,
  Calculator: Calculator,
  HeartHandshake: HeartHandshake,
  Lightbulb: Lightbulb
};

const PromoColumn = ({ title, items, testId }) => (
  <div className="mypes-promo-col" data-testid={testId}>
    <h4 className="mypes-promo-col-title">{title}</h4>
    <ul className="mypes-promo-list">
      {items.map((item, idx) => {
        const IconComponent = iconMap[item.icon];
        return (
          <li key={idx} className="mypes-promo-item">
            <div className="mypes-promo-item-icon">
              {IconComponent && <IconComponent size={22} />}
            </div>
            <div className="mypes-promo-item-text">
              <h5>{item.title}</h5>
              <p>{item.description}</p>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

const MypesPromoBanner = () => {
  return (
    <div className="mypes-promo" data-testid="mypes-promo">
      <div className="mypes-promo-header">
        <div className="mypes-promo-label">{mypesPromoData.label}</div>
        <h3 className="mypes-promo-title">
          {mypesPromoData.title}{' '}
          <span className="text-gold-gradient">{mypesPromoData.titleAccent}</span>
        </h3>
        <p className="mypes-promo-subtitle">{mypesPromoData.subtitle}</p>
      </div>

      <div className="mypes-promo-grid">
        <PromoColumn
          title={mypesPromoData.whyTitle}
          items={mypesPromoData.whyItems}
          testId="mypes-promo-why"
        />
        <PromoColumn
          title={mypesPromoData.howTitle}
          items={mypesPromoData.howItems}
          testId="mypes-promo-how"
        />
      </div>

      <div className="mypes-promo-cta">
        <div className="mypes-promo-cta-icon">
          <Lightbulb size={26} />
        </div>
        <p className="mypes-promo-cta-text">
          {mypesPromoData.ctaText}{' '}
          <strong>{mypesPromoData.ctaAccent}</strong>
        </p>
        <a
          href={`https://wa.me/${contactData.whatsappNumber}?text=${encodeURIComponent(mypesPromoData.ctaWhatsappMessage)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary mypes-promo-cta-button"
          data-testid="mypes-promo-cta-whatsapp"
        >
          <MessageCircle size={18} aria-hidden="true" />
          {mypesPromoData.ctaButton}
        </a>
      </div>

      <div className="mypes-promo-footer">
        <span>{mypesPromoData.footerLeft}</span>
        <span className="mypes-promo-footer-divider" aria-hidden="true" />
        <span className="mypes-promo-footer-accent">{mypesPromoData.footerRight}</span>
      </div>
    </div>
  );
};

export default MypesPromoBanner;
